<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <app-button @click.native="onShowModal(null)">Create</app-button>
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default table-default--40"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__name><div class="table-default__left">Name</div></template>
        <template #name="{ row }"><div class="table-default__left">{{ row.position.name }}</div></template>
        <template #controls="{ row }">
          <div class="table-default__controls">
            <button @click="onShowModal(row)" type="button">
              <img src="@/assets/img/edit-table-icon.svg" alt="Edit">
            </button>
            <button @click="onShowDeleteModal(row.id)" type="button">
              <img src="@/assets/img/delete-table-icon.svg" alt="Delete">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
    <modal
      name="equip_modal"
      :width="1000"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      class="modal-not-overflow"
      draggable=".popup__title"
    >
      <div class="popup">
        <button @click="onHideModal" class="popup__close" type="button"></button>
        <div class="popup__title">{{ item_to_action ? 'Update' : 'Create' }} crew</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm">
            <app-form-group label="Position" required>
              <app-select
                v-model="form.position"
                :options="position_options"
                :reduce="item => item.code"
                :readonly="item_to_action"
                placeholder="Position"
                :error="$v.form.position.$error"
              />
              <template #error>
                <div v-if="$v.form.position.$dirty && !$v.form.position.required">Required field</div>
              </template>
            </app-form-group>
            <app-flex-grid :rows="[['160px', 1, '80px', '80px', '80px', '130px']]" margin-bottom="20px" alignItems="end">
              <template #col-1-1>
                <app-form-group label="Route group" class="form-group--no-indent" required>
                  <app-select
                    v-model="form_create.calculation_group"
                    :options="route_group_options"
                    :reduce="item => item.code"
                    placeholder="Route group"
                    :error="$v.form_create.calculation_group.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_create.calculation_group.$dirty && !$v.form_create.calculation_group.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #col-1-2>
                <app-form-group label="Types" class="form-group--no-indent" required>
                  <app-select
                    v-model="form_create.types"
                    :options="types_options"
                    :reduce="item => item.code"
                    :closeOnSelect="false"
                    placeholder="Types"
                    multiple
                    :error="$v.form_create.types.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_create.types.$dirty && !$v.form_create.types.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #col-1-3>
                <app-form-group label="Min" class="form-group--no-indent" required label-for="min_create">
                  <app-input
                    v-model.number="form_create.min"
                    type="number"
                    placeholder="Min"
                    id="min_create"
                    :error="$v.form_create.min.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_create.min.$dirty && !$v.form_create.min.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #col-1-4>
                <app-form-group label="Max" class="form-group--no-indent" required label-for="max_create">
                  <app-input
                    v-model.number="form_create.max"
                    type="number"
                    placeholder="Max"
                    id="max_create"
                    :error="$v.form_create.max.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_create.max.$dirty && !$v.form_create.max.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #col-1-5>
                <app-form-group label="Count" class="form-group--no-indent" required label-for="count_create">
                  <app-input
                    v-model.number="form_create.count"
                    type="number"
                    placeholder="Count"
                    id="count_create"
                    :error="$v.form_create.count.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_create.count.$dirty && !$v.form_create.count.required">Required field</div>
                  </template>
                </app-form-group>
              </template>
              <template #col-1-6>
                <app-button @click.native="onAddItem">Add</app-button>
              </template>
            </app-flex-grid>
            <div class="arrange-popup__part">
              <div class="transfer-sortable transfer-sortable--full">
                <div v-for="(element, index) in form.pax_settings" :key="`own_item_${index}`" class="transfer-sortable__item transfer-sortable__item--mb-20">
                  <app-flex-grid :rows="[[1, 1, '80px', '80px', '80px']]" margin-bottom="0">
                    <template #col-1-1>
                      <app-form-group label="Route group" class="form-group--no-indent">
                        <app-select
                          v-model="element.calculation_group"
                          :options="route_group_options"
                          :reduce="item => item.code"
                          placeholder="Route group"
                          readonly
                        />
                      </app-form-group>
                    </template>
                    <template #col-1-2>
                      <app-form-group label="Types" class="form-group--no-indent">
                        <app-select
                          v-model="element.types"
                          :options="types_options"
                          :reduce="item => item.code"
                          :closeOnSelect="false"
                          placeholder="Types"
                          multiple
                          readonly
                        />
                      </app-form-group>
                    </template>
                    <template #col-1-3>
                      <app-form-group label="Min" class="form-group--no-indent" required>
                        <app-input
                          v-model.number="element.min"
                          type="number"
                          placeholder="Min"
                          :id="`min_${index}`"
                          readonly
                        />
                      </app-form-group>
                    </template>
                    <template #col-1-4>
                      <app-form-group label="Max" class="form-group--no-indent">
                        <app-input
                          v-model.number="element.max"
                          type="number"
                          placeholder="Max"
                          :id="`max_${index}`"
                          readonly
                        />
                      </app-form-group>
                    </template>
                    <template #col-1-5>
                      <app-form-group label="Count" class="form-group--no-indent">
                        <app-input
                          v-model.number="element.count"
                          type="number"
                          placeholder="Count"
                          :id="`count_${index}`"
                          readonly
                        />
                      </app-form-group>
                    </template>
                  </app-flex-grid>
                  <button
                    v-if="index"
                    @click="onRemoveItem(index)"
                    class="transfer-sortable__close"
                    type="button"
                  >
                    <img src="@/assets/img/delete-transfer.svg" alt="">
                  </button>
                </div>
              </div>
            </div>
            <app-cells position="center" :indent="false">
              <app-button ref="submit" type="submit">{{ item_to_action ? 'Save' : 'Create' }}</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="delete-modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('delete-modal')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete item
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this item?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('delete-modal')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteItem" ref="deleteItem">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  getClimbingGroupType,
  getClimbingRouteCalculation,
  getClimbingMountainCrewPositions,
  getClimbingCrewSettings,
  postClimbingCrewSettings,
  patchClimbingCrewSettings,
  deleteClimbingCrewSettings
} from '@/http'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ClimbingSettingsCrew',
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      position_options: [],
      types_options: [],
      route_group_options: [],
      form: {},
      form_create: {},
      item_to_action: null,
      table: {
        items: [],
        columns: [
          'name',
          'controls'
        ],
        options: {
          headings: {
            'name': 'Name',
            'controls': '',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  validations: {
    form: {
      position: { required },
    },
    form_create: {
      min: { required },
      max: { required },
      count: { required },
      types: { required },
      calculation_group: { required },
    }
  },
  created() {
    Promise.all([
      getClimbingMountainCrewPositions(),
      getClimbingGroupType(),
      getClimbingRouteCalculation(),
      this.fetchItems()
    ])
      .then(response => {
        this.position_options = response[0].data
        this.types_options = response[1].data
        this.route_group_options = response[2].data
        this.is_loaded = true
      })
  },
  methods: {
    async fetchItems() {
      this.table_preloader = true
      const response = await getClimbingCrewSettings({ page: this.pagination.page, page_size: 20 })
      this.table.items = response.data.results
      this.pagination.pages = response.data.pages
      this.pagination.count = response.data.count
      this.table_preloader = false
    },
    onCheckForm() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendForm()
      }
    },
    sendForm() {
      this.$refs.submit.preload = true
      if (!this.item_to_action) {
        postClimbingCrewSettings(this.form)
          .then(() => {
            this.fetchItems()
            this.onHideModal()
          })
          .catch(() => { this.$refs.submit.preload = false })
      } else {
        patchClimbingCrewSettings(this.item_to_action, {pax_settings: this.form.pax_settings})
          .then(() => {
            this.fetchItems()
            this.onHideModal()
          })
          .catch(() => { this.$refs.submit.preload = false })
      }
    },
    onShowModal(data) {
      this.item_to_action = data?.id
      this.form_create = {}
      if (!this.item_to_action) {
        this.form = {pax_settings: []}
      } else {
        this.form = {
          position: data.position,
          pax_settings: data.pax_settings.map(item => {
            return {
              ...item,
              calculation_group: item.calculation_group.code,
              types: item.types.map(({code}) => code)
            }
          }),
        }
      }
      this.$v.form.$reset()
      this.$modal.show('equip_modal')
    },
    onHideModal() {
      this.$modal.hide('equip_modal')
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    onAddItem() {
      this.$v.form_create.$touch()
      if (this.$v.form_create.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.form.pax_settings.push({...this.form_create})
        this.form_create.min = null
        this.form_create.max = null
        this.form_create.count = null
        this.$v.form_create.$reset()
      }
    },
    onRemoveItem(index) {
      this.form.pax_settings.splice(index, 1)
    },
    onShowDeleteModal(item_id) {
      this.item_to_action = item_id
      this.$modal.show('delete-modal')
    },
    onDeleteItem() {
      this.$refs.deleteItem.preload = true
      deleteClimbingCrewSettings(this.item_to_action)
        .then(() => {
          this.fetchItems()
          this.$notify({
            type: 'success',
            title: 'Item deleted',
          })
          this.$modal.hide('delete-modal')
        })
        .catch(() => {
          this.$refs.deleteItem.preload = false
        })
    },
  }
}
</script>
